import React, { useState } from "react";
import styles from "./ForgotPassword.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Password } from "primereact/password";
import { userActions } from "../../../store/auth-store/auth-slice";
import { uiActions } from "../../../store/ui-slice";
import { ChangePasswordAction } from "../../../store/auth-store/auth-actions";
import { Message } from "primereact/message";
import { Button } from "primereact/button";

let restartPage = false;

const ForgotPassword = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.auth);
  const notification = useSelector((state) => state.ui.notification);

  const [passwordIsValid, setPasswordIsvalid] = useState(true);
  const [repasswordIsValid, setRePasswordIsValid] = useState(true);

  const onChangeHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }
  };


  

  const getFormErrorMessage = (id) => {
    let response = <small className="p-warn">&nbsp;</small>;
    if (id === "password" && !passwordIsValid) {
      response = (
        <Message severity="warn" text="Debe Digitar una contraseña valida." />
      );
    }
    if (id === "repassword" && !repasswordIsValid) {
      response = (
        <Message severity="warn" text="Debe Digitar una contraseña valida." />
      );
    }
    return response;
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();
    if (user.password === "") {
      setPasswordIsvalid(false);
    } else if (user.repassword === "") {
      setRePasswordIsValid(false);
    } else if (user.password !== user.repassword) {
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Las contraseñas no coinciden",
        })
      );
    } else {
     await dispatch(
        ChangePasswordAction( 
          params.token,
          params.userId,
          user.password
        )
      );
      window.location.href = "/";

    }
  };

  return (
    <div className={styles.forgotPassword}>
    <div className={styles.contentBox}>
      <h1>Recuperar contraseña</h1>
      <Password
        feedback={false}
        className={styles.loginInput}
        value={user.password}
        type={user.password}
        onChange={(e) => onChangeHandler("password", e.target.value)}
        placeholder="Contraseña"
      />
      <div>{getFormErrorMessage("password")}</div>
      <Password
        feedback={false}
        className={styles.loginInput}
        value={user.repassword}
        type={user.repassword}
        onChange={(e) => onChangeHandler("repassword", e.target.value)}
        placeholder="Contraseña"
      />
      <div>{getFormErrorMessage("repassword")}</div>
        <Button className={styles.sendButton} onClick={onSubmitHandler}>Cambiar Contraseña</Button>
    </div>
    </div>
  );
};

export default ForgotPassword;
